export interface ProjectSummary {
	id: number;
	project_id: string;
	project_reference: string;
	capsule_id: string;
	org_name: string;
	allocated_days: number;
	allocated_days_id: number;
	minutes_worked: number;
	minutes_worked_id: number;
	minutes_remaining: number;
	minutes_remaining_id: number;
	page?: number;
	project_status: string;
}

export const emptyProject: ProjectSummary = {
	id: 0,
	project_id: "1",
	project_reference: "",
	capsule_id: "",
	org_name: "",
	minutes_worked: 0,
	allocated_days: 0,
	minutes_remaining: 0,
	minutes_worked_id: 0,
	allocated_days_id: 0,
	minutes_remaining_id: 0,
	project_status: "OPEN",
};
